export default "__VITE_ASSET__6c2f94ab__"